import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetShortStrings($locale: String!, $teamLabel: String!) {\n    simpleStringCollection(where: { teamLabel: $teamLabel }, locale: $locale, order: entryTitle_ASC) {\n      items {\n        entryTitle\n        key\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
import gql from 'graphql-tag';
// //query for getting all resources sets
// const ALL_RESOURCE_SETS_QUERY = gql`
//   query GetAllResourceSets($locale: String) {
//     resourceSetCollection {
//       items {
//         key
//         resourcesCollection(locale: $locale) {
//           items {
//             key
//             text
//           }
//         }
//       }
//     }
//   }
// `
// //query for getting a single resources set
// export const RESOURCE_SET_QUERY = gql`
//   query GetResourceSet($resourceSetId: String!, $locale: String) {
//     resourceSetCollection(where: { key: $resourceSetId }) {
//       items {
//         key
//         resourcesCollection(locale: $locale) {
//           items {
//             key
//             text
//           }
//         }
//       }
//     }
//   }
// `
//query for getting a single resources set
// export const getSingleResourceSet = (apolloClient: ApolloClient<any>) => (resourceSetId: string, locale = 'en') => {
//   return apolloClient.query({
//     query: RESOURCE_SET_QUERY,
//     variables: { resourceSetId: resourceSetId, locale: locale },
//   })
// }
// export const getAllResourceSets = (apolloClient: ApolloClient<any>) => (locale = 'en') => {
//   return apolloClient.query({
//     query: ALL_RESOURCE_SETS_QUERY,
//     variables: { locale: locale },
//   })
// }
export var SHORT_STRINGS_QUERY = gql(_templateObject());
export var getShortStrings = function getShortStrings(apolloClient) {
  return function (teamLabel) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    return apolloClient.query({
      query: SHORT_STRINGS_QUERY,
      variables: {
        teamLabel: teamLabel,
        locale: locale
      }
    });
  };
};